//export const BASEURL = "http://localhost/sge/api/v1/";
export const BASEURL = "https://cattspressoir.haitisolution.net/sge/api/v1/";
